import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=7175f961&scoped=true"
import script from "./ExamInfo.ts?vue&type=script&lang=ts&external"
export * from "./ExamInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./ExamInfo.vue?vue&type=style&index=0&id=7175f961&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175f961",
  null
  
)

export default component.exports